// @flow
import { combineReducers } from 'redux';
import { ACTIONS } from '../constants';
import type { NotificationLookup, Notification } from '../constants';

export function notificationsList(state: Array<number> = [], action: any = {}) {
    switch (action.type) {
        case ACTIONS.NOTIFICATIONS_LOADED:
            return action.notifications.map(
                (notification: Notification) => notification.id
            );
        case ACTIONS.RESET_ALL:
            return [];
        default:
            return state;
    }
}

export function notificationsLookup(
    state: NotificationLookup = {},
    action: any = {}
) {
    const lookup = {};
    const forEachNotification = (callback: Function) => {
        Object.keys(state).forEach((id: number) => callback(state[id]));
    };

    switch (action.type) {
        case ACTIONS.NOTIFICATIONS_LOADED:
            for (const notification of action.notifications) {
                lookup[notification.id] = notification;
            }
            return lookup;
        case ACTIONS.NOTIFICATIONS_VIEWED:
            forEachNotification((notification: Notification) => {
                lookup[notification.id] = { ...notification, isViewed: true };
            });

            return lookup;
        case ACTIONS.NOTIFICATIONS_READ:
            forEachNotification((notification: Notification) => {
                lookup[notification.id] = { ...notification, isRead: true };
            });

            return lookup;
        case ACTIONS.SINGLE_NOTIFICATION_READ:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    isRead: true
                }
            };
        case ACTIONS.RESET_ALL:
            return {};
        default:
            return state;
    }
}

export default combineReducers({
    notificationsList,
    notificationsLookup
});



// WEBPACK FOOTER //
// ./src/v5/notifications/state/notificationsReducer.js